
  export default {
    components: {},

    props: {
      modelValue: {
        type: String,
        default: '',
      },
      type: {
        type: String,
        default: 'large',
      },
      status: {
        type: Boolean,
        default: false,
      },
      statusMsg: {
        type: String,
        default: '',
      },
      placeholder: {
        type: String,
        default: '',
      },
      label: {
        type: String,
        default: '',
      },
      maxLength: {
        type: Number,
        default: 128,
      },
      required: {
        type: Boolean,
        default: false,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      typeInput: {
        type: String,
        default: 'text',
      },
      mask: {
        type: [String, Array, Function],
        default: null,
      },
      digitsOnly: {
        type: Boolean,
        default: false,
      },
      customElementText: {
        type: String,
        default: '',
      },
    },

    emits: [
      'update:modelValue',
      'update:status',
      'update:status-msg',
      'custom-click',
      'handle-input',
      'handle-paste',
      'handle-blur',
      'handle-focus',
      'handle-keydown',
    ],

    data() {
      return {
        firstBlur: false,
      }
    },

    computed: {},

    watch: {
      // Добавляем отслеживание изменения modelValue, чтобы при прямом изменении отрабатывала валидация
      modelValue: {
        handler(newValue) {
          this.defaultValidate(newValue)
        },
        immediate: true,
      },
    },

    mounted() {},

    methods: {
      sanitizeDigits(value) {
        return String(value ?? '').replace(/\D/g, '')
      },

      applyDigitsToInput(input, rawValue) {
        const value = this.digitsOnly ? this.sanitizeDigits(rawValue) : rawValue
        if (input.value !== value) {
          input.value = value
        }
        return value
      },

      emitInputValue(input, event) {
        const value = this.applyDigitsToInput(input, input.value)
        this.defaultValidate(value)
        this.$emit('update:modelValue', value)
        this.$emit('handle-input', event)
      },

      handleInput(event) {
        this.emitInputValue(event.target, event)
      },

      handlePaste(event) {
        if (!this.digitsOnly) {
          this.$emit('handle-paste', event)
          return
        }

        event.preventDefault()
        const input = event.target
        const paste = this.sanitizeDigits(
          event.clipboardData?.getData('text') ?? ''
        )
        const start = input.selectionStart ?? 0
        const end = input.selectionEnd ?? 0
        const merged =
          input.value.slice(0, start) + paste + input.value.slice(end)
        input.value = merged
        this.emitInputValue(input, event)
      },

      handleCompositionEnd(event) {
        if (!this.digitsOnly) return
        this.emitInputValue(event.target, event)
      },

      handleBlur(event) {
        this.firstBlur = true

        this.$emit('handle-blur', event)
      },
      handleFocus(event) {
        this.$emit('handle-focus', event)
      },
      handleKeydown(event) {
        if (this.digitsOnly) {
          const allowed = [
            'Backspace',
            'Delete',
            'ArrowLeft',
            'ArrowRight',
            'Tab',
            'Home',
            'End',
          ]
          const isDigit = /^\d$/.test(event.key)
          const isShortcut = event.ctrlKey || event.metaKey

          if (!allowed.includes(event.key) && !isDigit && !isShortcut) {
            event.preventDefault()
            return
          }
        }

        this.$emit('handle-keydown', event)
      },

      defaultValidate(value) {
        // Обнуляем статус ошибки перед новым перерасчетом
        this.$emit('update:status', false)
        this.$emit('update:status-msg', '')

        if (this.required && (!value || value.length === 0)) {
          this.$emit('update:status', true)
          this.$emit(
            'update:status-msg',
            this.$t('interface.validation.required_field_full')
          )
        }
      },

      customClick() {
        this.$emit('custom-click')
      },
    },
  }
